/* eslint-env browser */

'use strict';

var Select = require('./Select');

/**
 * Netx multiselect editor
 * @constructor
 * @extends Select
 */
var Multiselect = Select.extend('Multiselect', {
	/**
	 * @desc the list of items to pick from
	 * @type {array}
	 * @memberof Multiselect.prototype
	 * @override Select.prototype
	 */
	items: [],

	/**
	 * @memberof Multiselect.prototype
	 * @override Select.prototype
	 */
	template: [
		'<div class="container" style="position:relative">',
			'<select id="editor" multiple="multiple">',
				'{{#items}}',
					'<option value="{{.}}">{{.}}</option>',
				'{{/items}}',
			'</select>',
		'</div>'
	].join('\n'),

	/**
	 * @memberof Multiselect.prototype
	 * @override
	 * @param input
	 */
	initialize: function(grid, options) {
		var value = grid.behavior.getValue(this.event);
		if (!(value instanceof Array)) {
			value = [value];
		}
		this.initialValue = value;
		this.input.onchange = function(){};
	},

	/**
	 * @memberof Multiselect.prototype
	 * @override Select.prototype
	 * @returns {object} the current editor's value
	 */
	getEditorValue: function() {
		// Gather multiselect values
		var inputOptions = this.input.options;
		var value = [];
		for (var i = 0, c = inputOptions.length; i < c; i++) {
			if (inputOptions[i].selected) {
				value.push(inputOptions[i].value);
			}
		}
		return value;
	},

	/**
	 * @memberof Multiselect.prototype
	 * @override Select.prototype
	 */
	saveEditorValue: function(value) {
		var save = (
			!(value && value.join() === this.initialValue.join()) && // data changed
			this.grid.fireBeforeCellEdit(this.event.gridCell, this.initialValue, value, this) // proceed
		);

		if (save) {
			this.grid.behavior.setValue(this.event, value);
			this.grid.fireAfterCellEdit(this.event.gridCell, this.initialValue, value, this);
		}

		return save;
	},

	/**
	 * @memberof Multiselect.prototype
	 * @override Select.prototype
	 * @param {mixed} value
	 */
	setEditorValue: function(value) {
		// We need to break it up into an array if not already
		if (value && !Array.isArray(value)) {
			value = value.split(/\,\s{0,1}/);
		}
		var opts = this.input.options;
		for (var i = 0, c = opts.length, opt; i < c; i++) {
			opt = opts[i];
			if (value && value.indexOf(opt.value) > -1) {
				opt.selected = true;
			}
		}
	}

});

module.exports = Multiselect;
